import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  selectedPOI: [],
  existingPOI: null,
  pointOfInterests: [],
  poi: null
}

const pointOfInterestSlice = createSlice({
  name: 'pointOfInterest',
  initialState,
  reducers: {
    setSelectedPOI: (state, action) => {
      state.selectedPOI = action.payload
    },
    setExistingPOI: (state, action) => {
      state.existingPOI = action.payload
    },
    setPointOfInterests: (state, action) => {
      state.pointOfInterests = action.payload
    },
    setPOI: (state, action) => {
      state.poi = action.payload
    }
  }
})

export const {setSelectedPOI, setExistingPOI, setPointOfInterests, setPOI} = pointOfInterestSlice.actions

export const selectSelectedPOI = (state) => state.pointOfInterest.selectedPOI
export const selectExistingPOI = (state) => state.pointOfInterest.existingPOI
export const selectPointOfInterests = (state) => state.pointOfInterest.pointOfInterests
export const selectPOI = (state) => state.pointOfInterest.poi

export default pointOfInterestSlice.reducer
